import { render, staticRenderFns } from "./partner-recharge.vue?vue&type=template&id=b06d016a&scoped=true&"
import script from "./partner-recharge.vue?vue&type=script&lang=js&"
export * from "./partner-recharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d016a",
  null
  
)

export default component.exports